module.exports = __webpack_public_path__ + "img/smoke.f361711.gif";